<template>
    <span style="margin: .45rem 0.75rem .45rem .45rem;">
    <switches
        v-model="value"
        v-on:input="updateValue"
        :color="(value) ? 'success' : 'default'"
        :disabled="readonly"
        ></switches>
    </span>
</template>
<script>
import _ from 'lodash';
import V from 'voca';
import Switches from '../form-elements/CustomSwitchComponent';

export default {
    data() {
        return {
            value: this.content.active,
        }
    },

    props: ['content', 'config', 'updateBatch'],

    components: {
        Switches,
    },

    computed: {
        active() {
            return this.content.active;
        },
        readonly() {
            return _.indexOf(this.content.readonly, 'active') >= 0;
        },
    },

    watch: {
        active(newValue) {
            this.value = newValue;
        }
    },

    methods: {
        updateValue(value) {
            if (this.readonly) {
                this.value = this.active;
                return;
            }
            this.updateBatch([
                { id: this.content.id, $update: { active: value } },
            ], {
                setNotification: true,
            })
            .then(() => this.$forceUpdate());
        },

        formatLabel(value) {
            return V.capitalize(value).replace(/[\_]/g, ' ');
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/ActiveSwitchActionComponent.vue